<template>
  <div class="alert-label-container" :class="color" id="alert-label" :style="textStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    fontSize: {
      type: String,
      default: 'inhiriet'
    },
    textAlign: {
      type: String,
      default: 'inhiriet'
    },
    padding: {
      type: String,
      default: '0.35rem'
    },
    color: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    textStyle() {
      if (this.fullWidth)
      return `padding:${this.padding};
        width: calc(100% - 2 * ${this.padding} - 2px);
        text-align:${this.textAlign};
        font-size:${this.fontSize}`;
      // else
      return `padding:${this.padding};
        max-width: calc(100% - 2 * ${this.padding} - 2px);
        text-align:${this.textAlign};
        font-size:${this.fontSize}`;
    }
  }
}
</script>

<style scoped>
.alert-label-container {
  align-content: center;
  min-height: 1.25em;
  color: white;
  border-radius: 5px;
  background-color: #333;
  border: 1px solid #555;
  display: block;
  margin-bottom: 1em;
}
.alert-label-container.red {
  background-color: brown;
  border-color: red;
}
.alert-label-container.blue {
  background-color: #315370;
  border-color: #2196F3;
}
.alert-label-container.green {
  background-color: #31703f;
  border-color: #21f380;
}
.alert-label-container.none {
  background-color: inherit;
  border: none;
  color: var(--textColor);
}
</style>